module.exports = __webpack_public_path__ + "static/services-1-df5517bd104e77b729cd66d73e1d41c2.jpg";